export default __webpack_public_path__ + "static/char-33-anr-7586aa5efb7cdaa10a531d131299a152.gif";